import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

const base = (clientViewId) => `/views/${clientViewId}/servicios`;

export function listVendorDirectoryResolutionCases(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion${buildClientQuery(params)}`);
}

export function getVendorDirectoryResolutionCase(clientViewId, caseId) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}`);
}

export function generateVendorDirectoryResolutionCase(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/generar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function assignVendorDirectoryResolutionCase(clientViewId, caseId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}/asignar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function startVendorDirectoryResolutionReview(clientViewId, caseId) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}/iniciar-revision`, {
    method: "POST",
  });
}

export function recordVendorDirectoryResolutionDecision(clientViewId, caseId, body) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}/decisiones`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function deferVendorDirectoryResolutionCase(clientViewId, caseId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}/aplazar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function recomputeVendorDirectoryResolutionCase(clientViewId, caseId) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}/recomputar`, {
    method: "POST",
  });
}

export function previewVendorDirectoryResolutionChangeset(clientViewId, caseId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}/cambios/preview`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function applyVendorDirectoryResolutionChangeset(clientViewId, caseId, body) {
  return clientPortalRequest(`${base(clientViewId)}/resolucion/${caseId}/cambios/aplicar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
